const Navbar = require('../Navbar');
const NavbarItemSlidingSubmenu = require('./NavbarItemSlidingSubmenu');

class NavbarSlidingSubmenu extends Navbar {
  constructor(container) {
    super(container);
    if (!container || container.length === 0) {
      throw new Error('Navbar container is required.');
    }
    this.NavbarItemClass = NavbarItemSlidingSubmenu;
    this.currentMenuId = null;
    this.previousMenuId = null;
    // Correct selector: Find .sliding-submenu within the current container
    this.$slidingSubmenu = this.$container.find('.sliding-submenu');
    if (this.$slidingSubmenu.length === 0) {
      throw new Error('Sliding submenu container not found.');
    }
    this.isAnimating = false;

    // Initialize GSAP via Dependency Manager
    this.gsap = null;
    this.tl = null;
    $dependencyManager.addDependencyCallback('gsap', () => {
      this.gsap = window.gsap;
    });

    this.init();
    this.initNavItems();
    this.initContainer();
  }

  initNavItems() {
    super.initNavItems();
    
    // Constants for touch handling
    const LONG_PRESS_DURATION = 250;
    
    for (const navItem of this.navItems) {
      const navItemLink = navItem.$link;
      
      // Handle hover over nav item link with debounce (for desktop)
      jQuery(navItemLink).on('mouseenter', this.debounce((event) => {
        if (this.isAnimating || this.isTouchDevice()) return;
        if (navItem.$submenu.length > 0) {
          this.showSlidingSubmenu(navItem);
        } else {
          this.hideSlidingSubmenu();
        }
      }, 100));
  
      // Touch event handling for mobile
      if (navItem.$submenu.length > 0) {
        let touchTimer;
        let touchStartX, touchStartY;
        let preventClick = false;
        
        // Touch start - begin timing for long press
        jQuery(navItemLink).on('touchstart', (event) => {
          if (this.isAnimating) return;
          
          touchStartX = event.originalEvent.touches[0].clientX;
          touchStartY = event.originalEvent.touches[0].clientY;
          preventClick = false;
          
          touchTimer = setTimeout(() => {
            preventClick = true;
            this.showSlidingSubmenu(navItem);
          }, LONG_PRESS_DURATION);
        });
        
        // Touch end - handle link navigation if not a long press
        jQuery(navItemLink).on('touchend', (event) => {
          clearTimeout(touchTimer);
          
          if (preventClick) {
            event.preventDefault();
          }
        });
        
        // Touchmove - cancel long press if scrolling
        jQuery(navItemLink).on('touchmove', (event) => {
          const touchX = event.originalEvent.touches[0].clientX;
          const touchY = event.originalEvent.touches[0].clientY;
          
          if (Math.abs(touchX - touchStartX) > 10 || Math.abs(touchY - touchStartY) > 10) {
            clearTimeout(touchTimer);
          }
        });
        
        // Cancel long press if touch is canceled
        jQuery(navItemLink).on('touchcancel', () => {
          clearTimeout(touchTimer);
        });
      }
  
      // Öffne das Submenü bei Klick auf das Nav-Icon
      jQuery(navItem.$icon).on('click', (event) => {
        event.preventDefault();
        if (this.isAnimating) return;
        if (!navItem.isActive) {
          this.showSlidingSubmenu(navItem);
        } else {
          this.hideSlidingSubmenu();
        }
      });
    }
  }
  
  // Helper method to detect touch devices
  isTouchDevice() {
    return ('ontouchstart' in window) || 
           (navigator.maxTouchPoints > 0) || 
           (navigator.msMaxTouchPoints > 0);
  }

  // Debounce utility function
  debounce(func, delay) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), delay);
    };
  }

  showSlidingSubmenu(navItem) {
    if (this.currentMenuId === navItem.menuId) return;

    if (!this.validateGsap()) return;

    // Remove 'active' class from the previously active nav item
    if (this.currentMenuId) {
        const $previousNavItemLink = this.$container.find(`.mad-navbar__nav-item[data-menu-id="${this.currentMenuId}"] .mad-navbar__nav-item-link`);
        $previousNavItemLink.removeClass('active');
    }

    // Add 'active' class to the new nav item
    navItem.$link.addClass('active');

    this.previousMenuId = this.currentMenuId;
    this.currentMenuId = navItem.menuId;

    const submenuContent = navItem.$submenu.html();
    const direction = this.getSlidingDirection(this.previousMenuId, this.currentMenuId);

    // Calculate the position of the navItem relative to the navbar container
    const navItemOffset = navItem.$link.offset();
    const containerOffset = this.$container.offset();

    const navItemWidth = navItem.$link.outerWidth();
    const navItemHeight = navItem.$link.outerHeight();
    const relativeLeft = navItemOffset.left - containerOffset.left;

    // Dynamically set height of the submenu
    const parentSubmenuWrapper = navItem.$submenu;
    const submenuOffset = parentSubmenuWrapper.offset();
    const submenuWidth = parentSubmenuWrapper.outerWidth();
    const submenuHeight = parentSubmenuWrapper.outerHeight();

    // Calculate relative position
    let leftPosition = navItemOffset.left - containerOffset.left - 16;

    const windowWidth = window.innerWidth;
    if (windowWidth > 2120) {
        // For very wide displays, calculate the dynamic side padding.
        // The CSS uses: min(calc(100% - 200px), 1920px)
        // Calculate the effective container width and side padding.
        const calculatedContainerWidth = Math.min(windowWidth - 200, 1920);
        const sidePadding = (windowWidth - calculatedContainerWidth) / 2;
        leftPosition = navItemOffset.left - containerOffset.left - sidePadding;
    } else if (windowWidth > 1600) {
        // For displays between 1600 and 2120, apply fixed 116px offset. Consisting of 16px padding and 100px of Custom Calc min(calc(100% - 200px), 1920px).
        leftPosition = navItemOffset.left - containerOffset.left - 116;
    } else {
        // For displays below 1600, use default 16px offset.
        leftPosition = navItemOffset.left - containerOffset.left - 16;
    }


    // Create a new submenu element
    const $oldSubmenu = this.$slidingSubmenu.find('.mad-navbar__submenu');
    const $newSubmenu = jQuery('<div>', {
        class: 'mad-navbar__submenu',
        html: submenuContent
    }).addClass(`slide-in-${direction}`).css({
        //transform: direction === 'left' ? 'translateX(-100%)' : 'translateX(100%)',
        opacity: 0
    });

    this.$slidingSubmenu.append($newSubmenu);
    this.$slidingSubmenu.addClass('active');

    this.gsap.to(this.$slidingSubmenu, {
        duration: 0.2,
        left: leftPosition,
        top: navItemHeight * 2,
        width: submenuWidth,
        height: submenuHeight,
        ease: "power2.out",
        overwrite: 'auto'
    });

    // Animate the old submenu out if it exists
    if ($oldSubmenu.length > 0) {
        const directionOut = direction === 'left' ? 'translateX(100%)' : 'translateX(-100%)';
        this.gsap.to($oldSubmenu.get(0), {
            //transform: directionOut,
            opacity: 0,
            duration: 0.1,
            ease: "power2.out",
            onComplete: () => {
                $oldSubmenu.remove();
            },
            onInterrupt: () => {
                $oldSubmenu.remove();
            },
            overwrite: 'auto'
        });
    }

    // Animate the new submenu in
    this.gsap.to($newSubmenu.get(0), {
        transform: 'translateX(0)',
        opacity: 1,
        duration: 0.4,
        ease: "power2.out",
        overwrite: 'auto'
    });
  }

  hideSlidingSubmenu() {
    if (!this.currentMenuId) return;
    this.isAnimating = true;

    const $currentSubmenu = this.$slidingSubmenu.find('.mad-navbar__submenu').last();
    if ($currentSubmenu.length > 0) {
      this.gsap.to($currentSubmenu.get(0), {
        //transform: 'translateX(-100%)',
        opacity: 0,
        duration: 0.2,
        ease: "power2.out",
        onComplete: () => {
          $currentSubmenu.remove();
          this.currentMenuId = null;
          this.isAnimating = false;
        }
      });

      // Remove the active class from the nav item link based on currentMenuId
      const $activeNavItem = this.$container.find(`.mad-navbar__nav-item[data-menu-id="${this.currentMenuId}"] .mad-navbar__nav-item-link`);
      $activeNavItem.removeClass('active');

      this.$slidingSubmenu.removeClass('active');
    } else {
      this.isAnimating = false;
    }
  }

  getSlidingDirection(prevId, currentId) {
    if (prevId === null) return 'left';
    
    const prevIndex = this.navItems.findIndex(item => item.menuId === prevId);
    const currentIndex = this.navItems.findIndex(item => item.menuId === currentId);
    
    if (currentIndex > prevIndex) {
      return 'left';
    } else {
      return 'right';
    }
  }

  initContainer() {
    // Use jQuery to handle mouseleave and mouseenter events on the navbar container
    this.$container.on('mouseleave', () => {
      this.resetTimeout = setTimeout(() => {
        this.hideSlidingSubmenu();
      }, 150);
    });

    this.$container.on('mouseenter', () => {
      if (this.resetTimeout) {
        clearTimeout(this.resetTimeout);
        this.resetTimeout = null;
      }
    });
      
    // Close the submenu when clicking outside
    jQuery(document).on('click touchstart', (event) => {
      if (!this.currentMenuId) return;

      const $target = jQuery(event.target);
      if (!$target.closest(this.$container).length && 
          !$target.closest(this.$slidingSubmenu).length) {
        this.hideSlidingSubmenu();
      }
    });
  }

  // Helper method to validate GSAP
  validateGsap() {
    if (!this.gsap) {
      console.error('GSAP is not loaded yet.');
      return false;
    }
    return true;
  }
}

module.exports = NavbarSlidingSubmenu;